import { TFunction } from "i18next";
import { Fields } from "../types/SchemaFactory";
import { schemaFactory } from "./SchemaFactory";
import { ContactsFormValues } from "../domain/models/Contacts";

export const ContactsFields: Fields<ContactsFormValues> = {
    address: {
        min: 1,
        max: 1000,
        placeholderKey: "console.contacts.table.address",
        type: "text",
        optional: false,
        initial: "",
    },
    phone: {
        min: 8,
        max: 20,
        placeholderKey: "console.contacts.table.phone",
        type: "text",
        optional: false,
        initial: "",
        pattern: /^[\d\s\(\)\-\+]+$/,
        patternErrorKey: "errors.validation.invalidPhone",
    },
    email: {
        min: 1,
        max: 255,
        placeholderKey: "console.contacts.table.email",
        type: "text",
        optional: false,
        initial: "",
    },
    directorId: {
        type: "text",
        optional: true,
        initial: "",
    },
};

export const contactsSchemaFactory = (t: TFunction) => {
    return schemaFactory(t, ContactsFields);
};

